import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
const ActionBar = () => {
  const location = useLocation(); // Get the current location

  // Function to determine if a route is active
  const isActive = (path) => location.pathname === path;

  return (
    <div className="container">
      <div className="row g-2 bg-white rounded p-3 mt-3">
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp">
            <button
              type="button"
              className={`btn w-100 rounded ${
                isActive("/erp") ? "btn-success" : "btn-primary"
              }`}
            >
              Dashboard
            </button>
          </Link>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp/students">
            <button
              type="button"
              className={`btn w-100 rounded ${
                location.pathname.startsWith("/erp/students")
                  ? "btn-success"
                  : "btn-primary"
              }`}
            >
              Student Details
            </button>
          </Link>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp/staffs">
            <button
              type="button"
              className={`btn w-100 rounded ${
                location.pathname.startsWith("/erp/staffs")
                  ? "btn-success"
                  : "btn-primary"
              }`}
            >
              Staff Details
            </button>
          </Link>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp/fees">
            <button
              type="button"
              className={`btn w-100 rounded ${
                location.pathname.startsWith("/erp/fees")
                  ? "btn-success"
                  : "btn-primary"
              }`}
            >
              Fees Payment
            </button>
          </Link>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp/examinations">
            <button
              type="button"
              className={`btn w-100 rounded ${
                location.pathname.startsWith("/erp/examination")
                  ? "btn-success"
                  : "btn-primary"
              }`}
            >
              Examinations
            </button>
          </Link>
        </div>
        <div className="col-12 col-sm-6 col-md-4 col-lg-2 text-center">
          <Link to="/erp/admissions">
            <button
              type="button"
              className={`btn w-100 rounded ${
                location.pathname.startsWith("/erp/admissions")
                  ? "btn-success"
                  : "btn-primary"
              }`}
            >
              Admissions
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ActionBar;
